import { fmtMoney } from "@/lib/money";

const esc = (s) => String(s ?? "").replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));

export function printOrder(order, restaurantName = "") {
  const when = order.created_at ? new Date(order.created_at).toLocaleString("it-IT", { timeZone: "Europe/Rome", hour: "2-digit", minute: "2-digit", day: "2-digit", month: "2-digit" }) : "";
  const rows = order.items.map((it) => `
    <div class="row"><span class="qty">${it.quantity}×</span><span class="nm">${esc(it.name)}${it.variant ? ` <em>(${esc(it.variant)})</em>` : ""}</span><span class="pr">${esc(fmtMoney(it.unit_price * it.quantity, order.currency))}</span></div>
    ${it.options?.length ? `<div class="sub">${esc(it.options.join(", "))}</div>` : ""}
    ${it.notes ? `<div class="sub note">» ${esc(it.notes)}</div>` : ""}`).join("");
  const who = order.type === "takeaway" ? `ASPORTO · ritiro ${esc(order.pickup_time)}<br>${esc(order.customer_name)} ${esc(order.customer_surname)} ${esc(order.phone)}` : `TAVOLO ${esc(order.table || "-")}${order.customer_name ? ` · ${esc(order.customer_name)}` : ""}`;
  const html = `<!doctype html><html><head><meta charset="utf-8"><title>Comanda #${esc(order.order_no)}</title>
  <style>
    @page{size:80mm auto;margin:4mm}
    body{font-family:"Courier New",monospace;font-size:13px;width:72mm;margin:0;color:#000}
    h1{font-size:15px;text-align:center;margin:0 0 4px;text-transform:uppercase}
    .c{text-align:center}.big{font-size:22px;font-weight:bold;margin:6px 0}
    hr{border:0;border-top:1px dashed #000;margin:6px 0}
    .row{display:flex;gap:6px;margin-top:4px}.qty{width:28px;font-weight:bold;font-size:15px}.nm{flex:1;font-weight:bold}.pr{white-space:nowrap}
    .sub{margin-left:34px;font-size:12px}.note{font-style:italic}
    .tot{display:flex;justify-content:space-between;font-size:16px;font-weight:bold;margin-top:6px}
    em{font-style:normal;font-weight:normal}
  </style></head><body>
  <h1>${esc(restaurantName || "Comanda")}</h1>
  <div class="c">Ordine #${esc(order.order_no)} · ${esc(when)}</div>
  <div class="c big">${who}</div>
  <hr>${rows}<hr>
  ${order.notes ? `<div class="note">NOTE: ${esc(order.notes)}</div><hr>` : ""}
  <div class="tot"><span>TOTALE</span><span>${esc(fmtMoney(order.total, order.currency))}</span></div>
  <div class="c" style="margin-top:4px">${order.payment === "cassa" || order.source === "staff" ? "Pagamento alla cassa" : ""}</div>
  <script>window.onload=function(){window.print();setTimeout(function(){window.close()},500)}</script>
  </body></html>`;
  const w = window.open("", "_blank", "width=420,height=640");
  if (!w) return false;
  w.document.write(html);
  w.document.close();
  return true;
}
